module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_flatpack_mob-35b1ed2d981cdfa87228329b37399a14.png";